import MIS from "../assets/MIS.jpg";
import PTMS from "../assets/PMS.png";
import TVMS from "../assets/TVMS.jpeg";
import SICD from "../assets/SICD.jpeg";
import SLR from "../assets/SLR.jpg";
import portfolio from "../assets/portfolio.webp";
import restaurantImage from "../assets/restaurant.jpg";
import FOMS from "../assets/FOMS.jpeg";
import RBCB from "../assets/RBCB.png";

import Clones from "../assets/Clone-apps.png";

import Taskier from "../assets/Taskier.jpg";

const Projects = [
  {
    title: "Management Information System",
    technologies: [
      {
        name: "Corporate project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "React",
        style: "text-blue-700 bg-blue-50 ring-blue-600/10",
      },
      {
        name: "Redis",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-green-700 bg-green-50 ring-green-600/10",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "NumPy",
        style: "text-yellow-700 bg-yellow-50 ring-yellow-600/10",
      },
      {
        name: "Pandas",
        style: "text-yellow-700 bg-yellow-50 ring-yellow-600/10",
      },
    ],
    description: `A comprehensive web application designed to monitor and analyze various company operations dealing with a large amount of data. 
      It utilizes technologies such as React for the frontend, Django for the backend, Redis for caching, and MySQL for data management.
      The system provides real-time analytics, dashboards, and reporting tools to enhance decision-making and operational efficiency within the organization.`,
    image: MIS,
    link: "",
  },
  {
    title: "Project Tracker Management System",
    technologies: [
      {
        name: "Corporate project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Angular",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "Material-UI",
        style: "text-teal-700 bg-teal-50 ring-teal-600/10",
      },
    ],
    description: `A robust web application created to facilitate the tracking and management of employee tasks and projects. 
      Developed using Angular for the frontend, Django for the backend, and MySQL for database management,
      this system allows for efficient assignment of tasks, progress tracking, and reporting,
      thereby improving team productivity and project oversight.`,
    image: PTMS,
    link: "",
  },
  {
    title: "Transport Vehicle Management System",
    technologies: [
      {
        name: "Corporate project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Angular",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "Ionic",
        style: "text-teal-700 bg-teal-50 ring-teal-600/10",
      },
      // {
      //   name: "Material-UI",
      //   style: "text-teal-700 bg-teal-50 ring-teal-600/10",
      // },
    ],
    description: `A specialized web application built to streamline the registration and management of transportation vehicles, drivers, goods, and services within a company. 
      Utilizing Angular for a dynamic user interface, Django for backend processing, and MySQL for secure data storage,
      this system ensures effective tracking and management of all transportation-related activities.`,
    image: TVMS,
    link: "",
  },
  {
    title: "Incentives Calculations and Distribution Management System.",
    technologies: [
      {
        name: "Corporate project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Angular",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "Material-UI",
        style: "text-teal-700 bg-teal-50 ring-teal-600/10",
      },
    ],
    description: `A web application developed to automate the calculation and distribution of employee incentives within a company. 
      This system is designed to accurately calculate incentives based on predefined criteria, track performance metrics, and ensure timely distribution of rewards.
      It leverages Angular, Django, MySQL to provide a user-friendly interface, secure data handling, and efficient management of the entire incentive distribution process.
      The system aims to enhance transparency, motivate employees, and streamline the incentive management workflow.`,
    image: SICD,
    link: "",
  },
  {
    title: "Sign Language Recognition and Vice-versa system",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Tkinter",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "Pandas",
        style: "text-violet-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Numpy",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "SKlearn",
        style: "text-orange-800 bg-orange-100 ring-orange-700",
      },
    ],
    description: `An innovative desktop application aimed at assisting individuals who are deaf and mute. 
      The system uses machine learning to convert captured hand gesture signs into text
      and also translates regional languages into hand gestures, displayed to the user.
      It is developed using Python with the Django framework and various pip packages,
      providing an accessible communication tool for those with hearing and speech impairments.`,
    image: SLR,
    link: "",
  },
  {
    title: "Portfolio",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "React",
        style: "text-blue-700 bg-blue-50 ring-blue-600/10",
      },
      {
        name: "Three.js",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Tailwind css",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
    ],
    description: `A personal web application designed to showcase professional skills, projects, and experiences. 
      This portfolio features a clean, modern design with sections highlighting key topics like work experience, work samples, and technical expertise.
      Built using React, Tailwind CSS, Three.js, the portfolio includes interactive elements, smooth navigation, and responsive design, ensuring an optimal viewing experience across devices.
      This portfolio serves as a dynamic and engaging representation of professional capabilities and personal brand.`,
    image: portfolio,
    link: "",
  },
  {
    title: "Restaurant Management System",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "React",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Angular",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "Bootstrap",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
    ],
    description: `A web application developed to streamline the operations of a restaurant, including table reservations, order management, billing, and inventory control. 
      The system is built with enabling efficient management of day-to-day activities and enhancing the overall customer experience.`,
    image: restaurantImage,
    link: "",
  },
  {
    title: "Food Ordering Management System",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "React",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Angular",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "Bootstrap",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
    ],
    description: `A web application designed to facilitate online food ordering and delivery services. 
      This system allows customers to browse menus, place orders, and track delivery in real-time.
      It is developed ensuring seamless and user-friendly interaction between customers, restaurants, and delivery personnel.`,
    image: FOMS,
    link: "",
  },
  {
    title: "Retrieval Based Chatbot",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "python",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "NLP",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
      {
        name: "SkLearn",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "TensorFlow",
        style: "text-violet-700 bg-red-50 ring-red-600/10",
      },
    ],
    description: `A chatbot application designed to assist users by retrieving and delivering precise information from a predefined database. 
      It leverages natural language processing to understand user queries and fetch the most relevant responses.
      The system is developed using technologies like.. Python, TensorFlow, Django, ensuring efficient and accurate communication.`,
    image: RBCB,
    link: "",
  },
  {
    title: "Clone Apps: Deliveroo, Tinder, Uber, Signal",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "React Native",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "OAuth & JWT",
        style: "text-yellow-800 bg-yellow-50 ring-yellow-600",
      },
    ],
    description: `A comprehensive mobile applications development that replicate the functionalities of popular platforms like Deliveroo, Tinder, Uber, and Signal. 
      This suite includes a food ordering and delivery system, a social networking platform for swiping and matching, a ride-hailing service for booking and tracking rides,
      and a secure communication app offering end-to-end encrypted messaging and calls. Developed using technologies such as React Native, Django.
      These clones provide seamless, user-friendly experiences while demonstrating the ability to recreate complex systems with precision and functionality.`,
    image: Clones,
    link: "",
  },
  {
    title: "Taskier: a To-Do List Application",
    technologies: [
      {
        name: "Individual Project",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "React",
        style: "text-red-700 bg-red-50 ring-red-600/10",
      },
      {
        name: "Django",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
      {
        name: "MySQL",
        style: "text-indigo-700 bg-indigo-50 ring-indigo-600/10",
      },
      {
        name: "Tailwind css",
        style: "text-purple-700 bg-purple-50 ring-purple-700",
      },
    ],
    description: `A productivity application named Taskier, designed to help users manage their tasks and organize their daily activities. 
      The app offers features like task creation, deadline setting, reminders, and categorization.
      Taskier is developed with a clean, intuitive interface for effective task management.`,
    image: Taskier,
    link: "",
  },
];

export default Projects;
